import { api } from '@/shared/api/client';
import type {
  CreateCheckoutSessionRequest,
  CreateCheckoutSessionResponse,
} from '../model/dto';

export const postCreateCheckoutSession = async (
  payload: CreateCheckoutSessionRequest
) => {
  const { data } = await api.post<CreateCheckoutSessionResponse>(
    '/stripe/create_checkout_session/',
    payload
  );
  return data;
};
